import React from "react";
import range from "lodash/range";
import moment from "moment-timezone";

export const birthDays = () => {
  const inputs = [];

  inputs.push(
    <option key="placeholder" disabled>
      Day
    </option>,
  );

  range(1, 32).forEach((item) => {
    inputs.push(
      <option value={item} key={item}>
        {item}
      </option>,
    );
  });

  return inputs;
};

export const birthMonths = () => {
  const inputs = [];

  inputs.push(
    <option key="placeholder" disabled>
      Month
    </option>,
  );

  moment.months().forEach((item, key) => {
    inputs.push(
      <option value={key + 1} key={item}>
        {item}
      </option>,
    );
  });

  return inputs;
};

export const birthYears = () => {
  const inputs = [];

  inputs.push(
    <option key="placeholder" disabled>
      Year
    </option>,
  );

  range(new Date().getFullYear() - 18, 1900, -1).forEach((item) => {
    inputs.push(
      <option value={item} key={item}>
        {item}
      </option>,
    );
  });

  return inputs;
};
